import i18next from 'i18next';

i18next.addResources('en', 'MaturationCaskAmount', {
  usedCasks: 'Casks used to make this whisky',
  casksDescription: 'All of our casks mature in warehouses situated next to the distillery.'
});
